export const MCP_TRANSPORT_OPTIONS = [
  { value: 'streamable_http', label: 'Streamable HTTP' },
  { value: 'http', label: 'HTTP' },
  { value: 'sse', label: 'SSE' },
];

export const MCP_AUTH_TYPE_OPTIONS = [
  { value: 'none', label: 'Sem autenticação' },
  { value: 'bearer', label: 'Bearer token' },
];

export const OAUTH_TOKEN_AUTH_METHOD_OPTIONS = [
  { value: '', label: 'Detectar pelo segredo cadastrado' },
  { value: 'none', label: 'Cliente público (sem segredo)' },
  { value: 'client_secret_post', label: 'Segredo no corpo (client_secret_post)' },
  { value: 'client_secret_basic', label: 'Segredo em Basic (client_secret_basic)' },
];

export const EMPTY_MCP_SERVER_FORM = {
  slug: '',
  label: '',
  url: '',
  transport: 'streamable_http',
  auth_type: 'none',
  token: '',
  is_active: true,
};

export function mapMcpServerFromApi(entry) {
  return {
    slug: entry.slug || '',
    label: entry.label || '',
    url: entry.url || '',
    transport: entry.transport || 'streamable_http',
    auth_type: entry.auth_type || 'none',
    token: '',
    is_active: Boolean(entry.is_active),
    tokenConfigured: Boolean(entry.token_configured),
  };
}

export function buildMcpServerPayload(form, { isEdit = false } = {}) {
  const payload = {
    label: form.label.trim(),
    url: form.url.trim(),
    transport: form.transport,
    auth_type: form.auth_type,
    is_active: form.is_active,
  };

  if (!isEdit) {
    payload.slug = form.slug.trim().toLowerCase();
  }

  if (form.token.trim()) {
    payload.token = form.token.trim();
  }

  return payload;
}
